/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Struct field representation.
 */
export interface StructClaimValue {
    /** The struct field value. */
    value: Truvity.CredentialClaimValues;
}
